module.exports = __webpack_public_path__ + "static/media/videoLibraryRightArrow.045967c4.svg";